import React from 'react';
import '../less/acquiring.less';
import FAQStorybook from '@abank/abank-faq';
import QuestionsAdminNew from '../../../auxiliary-components/shared/QuestionsAdminNew';
import hero_img from '../img/acquiring/hero_img.webp';
import Hero from '../../../auxiliary-components/shared/HeroBlock';
import hero_data from '../enums/acquiring/hero_data.json';
import { businessBannerAwardFop, businessAllDigitalAwardLink, fiscalizationMoreLinkEcheck, fiscalizationGooglePlayLinkEcheck, fiscalizationMoreLinkPayKitPOS, fiscalizationGooglePlayLinkPayKitPOS, fiscalizationMoreLinkCashalot, fiscalizationGooglePlayLinkCashalot, fiscalizationMoreLinkSmPos, fiscalizationGooglePlayLinkSmPos, fiscalizationMoreLinkCheckbox, fiscalizationGooglePlayLinkCheckbox, fiscalizationMoreLinkOnlineKasa, fiscalizationGooglePlayLinkOnlineKasa, fiscalizationMoreLinkSmartKasa, fiscalizationGooglePlayLinkSmartKasa, fiscalizationMoreLinkVchasno, fiscalizationGooglePlayLinkVchasno, taptophoneAPayLink, fiscalizationMoreLinkServio, fiscalizationMoreLinkShopExpress, fiscalizationMoreLinkEatScanPay, fiscalizationMoreLinkStravopys, fiscalizationMoreLinkChekly, fiscalizationMoreLinkWordPress, fiscalizationMoreLinkOpenChart, fiscalizationMoreLinkNetHunt, fiscalizationMoreLinkKey, fiscalizationMoreLinkUspacy, fiscalizationMoreLinkApi } from '../../../services/urls/urls';
import { filterByEnvironment } from '../../../helpers/utils/environmentFilter';
import Tabs from '../../../auxiliary-components/shared/Tabs';
import topBlockTaptophoneData from '../enums/acquiring/top_block_taptophone_data.json';
import topBlockPosData from '../enums/acquiring/top_block_pos_data.json';
import topBlockQrData from '../enums/acquiring/top_block_qr_data.json';
import fiscalizationTaptophoneItemsData from '../enums/acquiring/fiscalization_taptophone_items.json';
import fiscalizationPosItemsData from '../enums/acquiring/fiscalization_pos_items.json';
import howToBlockData from '../enums/acquiring/how_to_block_data.json';
import how_to_block_img_1 from '../img/acquiring/how_to_block_img_1.webp';
import how_to_block_img_2 from '../img/acquiring/how_to_block_img_2.webp';
import how_to_block_img_3 from '../img/acquiring/how_to_block_img_3.webp';
import how_to_block_img_4 from '../img/acquiring/how_to_block_img_4.webp';
import HowToBlockNew from '../../../auxiliary-components/shared/HowToBlockNew';
import businessFormatReviewItemsData from '../enums/acquiring/business_format_review_items.json';
import advantagesReviewItems from '../enums/acquiring/advantages_review_items.json';
import TitleBlock from '../../../auxiliary-components/shared/TitleBlock';
import TextBlock from '../../../auxiliary-components/shared/TextBlock';
import hero_award_img_01 from '../img/acquiring/hero_award_img_01.svg';
import hero_award_img_02 from '../img/acquiring/hero_award_img_02.svg';
import taptophone_top_img from '../img/acquiring/taptophone_top_img.webp';
import { getSafeLinkProps } from '../../../helpers/utils/urlSecurity';
import google_play_icon from '../img/acquiring/google_play_icon.svg';
import fiscalization_img_echeck from '../img/acquiring/fiscalization_img_echeck.webp';
import fiscalization_img_paykit_pos from '../img/acquiring/fiscalization_img_paykit_pos.webp';
import fiscalization_img_cashalot from '../img/acquiring/fiscalization_img_cashalot.webp';
import fiscalization_img_smpos from '../img/acquiring/fiscalization_img_smpos.webp';
import fiscalization_img_checkbox from '../img/acquiring/fiscalization_img_checkbox.webp';
import fiscalization_img_online_kasa from '../img/acquiring/fiscalization_img_online_kasa.webp';
import fiscalization_img_smart_kasa from '../img/acquiring/fiscalization_img_smart_kasa.webp';
import fiscalization_img_vchasno from '../img/acquiring/fiscalization_img_vchasno.webp';
import fiscalization_img_servio from '../img/acquiring/fiscalization_img_servio.webp';
import fiscalization_img_shop_express from '../img/acquiring/fiscalization_img_shop_express.webp';
import fiscalization_img_eat_scan_pay from '../img/acquiring/fiscalization_img_eat_scan_pay.webp';
import fiscalization_img_stravopys from '../img/acquiring/fiscalization_img_stravopys.webp';
import fiscalization_img_chekly from '../img/acquiring/fiscalization_img_chekly.webp';
import fiscalization_img_word_press from '../img/acquiring/fiscalization_img_word_press.webp';
import fiscalization_img_open_chart from '../img/acquiring/fiscalization_img_open_chart.webp';
import fiscalization_img_net_hunt from '../img/acquiring/fiscalization_img_net_hunt.webp';
import fiscalization_img_key from '../img/acquiring/fiscalization_img_key.webp';
import fiscalization_img_uspacy from '../img/acquiring/fiscalization_img_uspacy.webp';
import fiscalization_img_api from '../img/acquiring/fiscalization_img_api.webp';
import pos_top_img from '../img/acquiring/pos_top_img.webp';
import qr_top_img from '../img/acquiring/qr_top_img.webp';
import ButtonStorybook from '@abank/abank-button';
import internet_top_img from '../img/acquiring/internet_top_img.webp';
import topBlockInternetData from '../enums/acquiring/top_block_internet_data.json';
import BusinessOrder from '../../BusinessOrder';
import vending_top_img from '../img/acquiring/vending_top_img.webp';
import topBlockVendingData from '../enums/acquiring/top_block_vending_data.json';
import fiscalizationVendingItemsData from '../enums/acquiring/fiscalization_vending_items.json';
import fiscalizationInternetFiscalizationItemsData from '../enums/acquiring/fiscalization_internet_fiscalization_items.json';
import fiscalizationInternetIntegrationsItemsData from '../enums/acquiring/fiscalization_internet_integrations_items.json';
import fiscalizationInternetCmsItemsData from '../enums/acquiring/fiscalization_internet_cms_items.json';
import fiscalizationInternetCrmItemsData from '../enums/acquiring/fiscalization_internet_crm_items.json';
import fiscalizationInternetApiItemsData from '../enums/acquiring/fiscalization_internet_api_items.json';

export default function template() {
  const page = 'business-acquiring';

  const urlsMap = {
    businessBannerAwardFop,
    businessAllDigitalAwardLink,
    fiscalizationMoreLinkEcheck,
    fiscalizationGooglePlayLinkEcheck,
    fiscalizationMoreLinkPayKitPOS,
    fiscalizationGooglePlayLinkPayKitPOS,
    fiscalizationMoreLinkCashalot,
    fiscalizationGooglePlayLinkCashalot,
    fiscalizationMoreLinkSmPos,
    fiscalizationGooglePlayLinkSmPos,
    fiscalizationMoreLinkCheckbox,
    fiscalizationGooglePlayLinkCheckbox,
    fiscalizationMoreLinkOnlineKasa,
    fiscalizationGooglePlayLinkOnlineKasa,
    fiscalizationMoreLinkSmartKasa,
    fiscalizationGooglePlayLinkSmartKasa,
    fiscalizationMoreLinkVchasno,
    fiscalizationGooglePlayLinkVchasno,
    taptophoneAPayLink,
    fiscalizationMoreLinkServio,
    fiscalizationMoreLinkShopExpress,
    fiscalizationMoreLinkEatScanPay,
    fiscalizationMoreLinkStravopys,
    fiscalizationMoreLinkChekly,
    fiscalizationMoreLinkWordPress,
    fiscalizationMoreLinkOpenChart,
    fiscalizationMoreLinkNetHunt,
    fiscalizationMoreLinkKey,
    fiscalizationMoreLinkUspacy,
    fiscalizationMoreLinkApi
  };

  const handlersMap = {
    scrollToOrderBlock: this.scrollToOrderBlock,
    getConsult: this.toggleModal
  };

  const imagesMap = {
    how_to_block_img_1,
    how_to_block_img_2,
    how_to_block_img_3,
    how_to_block_img_4,
    hero_award_img_01,
    hero_award_img_02,
    taptophone_top_img,
    fiscalization_img_echeck,
    fiscalization_img_paykit_pos,
    fiscalization_img_cashalot,
    fiscalization_img_smpos,
    fiscalization_img_checkbox,
    fiscalization_img_online_kasa,
    fiscalization_img_smart_kasa,
    fiscalization_img_vchasno,
    fiscalization_img_servio,
    pos_top_img,
    qr_top_img,
    internet_top_img,
    vending_top_img,
    fiscalization_img_shop_express,
    fiscalization_img_eat_scan_pay,
    fiscalization_img_stravopys,
    fiscalization_img_chekly,
    fiscalization_img_word_press,
    fiscalization_img_open_chart,
    fiscalization_img_net_hunt,
    fiscalization_img_key,
    fiscalization_img_uspacy,
    fiscalization_img_api
  }
  
  const tabs = [{tab: 'review', title: 'ACQUIRING_NEW_TABS_TITLE_01'},
          {tab: 'pos', title: 'ACQUIRING_NEW_TABS_TITLE_02'},
          {tab: 'taptophone', title: 'ACQUIRING_NEW_TABS_TITLE_03'},
          {tab: 'qr', title: 'ACQUIRING_NEW_TABS_TITLE_04'},
          {tab: 'internet', title: 'ACQUIRING_NEW_TABS_TITLE_05'},
          {tab: 'vending', title: 'ACQUIRING_NEW_TABS_TITLE_06'}];
 
  const tabsInternetIntegration =
          [{tab: 'fiscalization', title: 'ACQUIRING_NEW_INTERNET_INTEGRATION_TABS_TITLE_01'},
          {tab: 'integrations', title: 'ACQUIRING_NEW_INTERNET_INTEGRATION_TABS_TITLE_02'},
          {tab: 'cms', title: 'ACQUIRING_NEW_INTERNET_INTEGRATION_TABS_TITLE_03'},
          {tab: 'crm', title: 'ACQUIRING_NEW_INTERNET_INTEGRATION_TABS_TITLE_04'},
          {tab: 'api', title: 'ACQUIRING_NEW_INTERNET_INTEGRATION_TABS_TITLE_05'}];

  const heroData = {
    ...hero_data,
    cards: hero_data.cards.map(card => ({
      ...card,
      img: imagesMap[card.img],
      href: urlsMap[card.href]
    }))
  };

  const howToBlockItems = howToBlockData.map(item => ({
    ...item,
    img: imagesMap[item.img]
  }));

  const mapTopBlockData = data => ({
    ...data,
    img: imagesMap[data.img],
    btn: data.btn && {...data.btn, onClick: handlersMap[data.btn.onClick]},
    link: data.link && {...data.link, href: urlsMap[data.link.href]}
  });

  const topBlockTaptophone = mapTopBlockData(topBlockTaptophoneData);
  const topBlockPos = mapTopBlockData(topBlockPosData);
  const topBlockQr = mapTopBlockData(topBlockQrData);
  const topBlockInternet = mapTopBlockData(topBlockInternetData);
  const topBlockVending = mapTopBlockData(topBlockVendingData);

  const renderTopBlock = data => {
    const titleId = `acquiring-${data.id}-top-block-title`;

    return (
      <section className="top-block" aria-labelledby={titleId}>
        <div className="container">
          <h3 id={titleId} className="top-block__title">{this.l10n(data.title)}</h3>
          <p className="top-block__text">{this.l10n(data.text)}</p>
          <div className="top-block__body">
            <div className="top-block__left">
              <img className="top-block__image" src={data.img} alt={data.alt ? this.l10n(data.alt) : ''} />
            </div>
            <div className="top-block__right right-top-block">
              {data.lists.map((list, listIndex) => (
                <React.Fragment key={listIndex}>
                  <h4 className="right-top-block__title">{this.l10n(list.title)}</h4>
                  <ul className="right-top-block__items">
                    {list.items.map((item, index) => (
                      <li key={index} className="right-top-block__item">{this.l10n(item)}</li>
                    ))}
                  </ul>
                </React.Fragment>
              ))}
              {(data.btn || data.link) && (
                <div className="right-top-block__btns">
                  {data.btn && (
                    <ButtonStorybook
                      type="button"
                      className="right-top-block__btn"
                      label={this.l10n(data.btn.text)}
                      onClick={data.btn.onClick}
                      size={"medium"}
                    />
                  )}
                  {data.link && (
                    <ButtonStorybook
                      className="right-top-block__btn"
                      label={this.l10n(data.link.text)}
                      aria-label={`${this.l10n(data.link.text)} (${this.l10n('OPENS_IN_NEW_TAB')})`}
                      {...getSafeLinkProps(data.link.href, { target: '_blank' })}
                      size={"medium"}
                    />
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    );
  };

  const mapFiscalizationData = items => items.map(item => ({
    ...item,
    img: imagesMap[item.img],
    hrefMore: urlsMap[item.hrefMore],
    hrefGooglePlay: urlsMap[item.hrefGooglePlay]
  }));

  const fiscalizationTaptophoneItems = mapFiscalizationData(fiscalizationTaptophoneItemsData);
  const fiscalizationPosItems = mapFiscalizationData(fiscalizationPosItemsData);
  const fiscalizationVendingItems = mapFiscalizationData(fiscalizationVendingItemsData);
  const fiscalizationInternetFiscalizationItems = mapFiscalizationData(fiscalizationInternetFiscalizationItemsData);
  const fiscalizationInternetIntegrationsItems = mapFiscalizationData(fiscalizationInternetIntegrationsItemsData);
  const fiscalizationInternetCmsItems = mapFiscalizationData(fiscalizationInternetCmsItemsData);
  const fiscalizationInternetCrmItems = mapFiscalizationData(fiscalizationInternetCrmItemsData);
  const fiscalizationInternetApiItems = mapFiscalizationData(fiscalizationInternetApiItemsData);

  const renderFiscalization = ({id, title, items}) => {
    const titleId = `acquiring-${id}-fiscalization-title`;
    const Wrapper = title ? 'section' : 'div';

    return (
      <Wrapper className="fiscalization" {...(title && {'aria-labelledby': titleId})}>
        <div className="container">
          {title && <h3 id={titleId} className="fiscalization__title">{this.l10n(title)}</h3>}
          <ul className="fiscalization__row">
            {items.map((item, index) => (
              <li key={index} className="fiscalization__item item-fiscalization">
                <img className="item-fiscalization__image" src={item.img} alt={item.alt ? this.l10n(item.alt) : ''} />
                <div className="item-fiscalization__content">
                  <h4 className="item-fiscalization__title">{this.l10n(item.title)}</h4>
                  <p className="item-fiscalization__text">{this.l10n(item.text)}</p>
                  <div className="item-fiscalization__btns">
                    <ButtonStorybook
                      className="item-fiscalization__btn"
                      label={this.l10n('ACQUIRING_NEW_FISCALIZATION_BTN_MORE')}
                      aria-label={`${this.l10n('ACQUIRING_NEW_FISCALIZATION_BTN_MORE')}: ${this.l10n(item.title)} (${this.l10n('OPENS_IN_NEW_TAB')})`}
                      {...getSafeLinkProps(item.hrefMore, { target: '_blank' })}
                      size={"medium"}
                    />
                    {item.hrefGooglePlay && (
                      <ButtonStorybook
                        className="item-fiscalization__btn item-fiscalization__btn_transparent"
                        label={this.l10n('ACQUIRING_NEW_FISCALIZATION_BTN_GOOGLE_PLAY')}
                        leadingIcon={google_play_icon}
                        aria-label={`${this.l10n('ACQUIRING_NEW_FISCALIZATION_BTN_GOOGLE_PLAY')}: ${this.l10n(item.title)} (${this.l10n('OPENS_IN_NEW_TAB')})`}
                        {...getSafeLinkProps(item.hrefGooglePlay, { target: '_blank' })}
                        size={"medium"}
                      />
                    )}
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </Wrapper>
    );
  };

  const questionsWidgets = {
    review: this.widgetsHelper.getWidget.call(this, 'questions'),
    taptophone: this.widgetsHelper.getWidgetFrom.call(this, 'widgets_taptophone', 'questions'),
    pos: this.widgetsHelper.getWidgetFrom.call(this, 'widgets_pos', 'questions'),
    qr: this.widgetsHelper.getWidgetFrom.call(this, 'widgets_qr', 'questions'),
    internet: this.widgetsHelper.getWidgetFrom.call(this, 'widgets_internet', 'questions'),
    vending: this.widgetsHelper.getWidgetFrom.call(this, 'widgets_vending', 'questions')
  };

  return (
    <div className="module-business-acquiring">
      <Hero
        data={heroData}
        img={hero_img}
        imgAlt={'ACQUIRING_NEW_HERO_IMG_ALT'}
        page={page}
      />
      <div className={`content${this.state.faqTab ? ' hidden' : ''}`}>
        <Tabs tabs={tabs} toggle={this.toggleTab} tab={this.state.tab} title={'ACQUIRING_NEW_TABS_TITLE'} id={'top-tabs'}>
          <>
            <div>
              <TitleBlock title={'ACQUIRING_NEW_REVIEW_TOP_TITLE'} tag={"h3"}/>
              <TextBlock text={'ACQUIRING_NEW_REVIEW_TOP_TEXT'}/>
            </div>
            <section className="business-format" aria-labelledby="acquiring-business-format-title">
              <div className="container">
                <h3 id="acquiring-business-format-title" className="business-format__title">{this.l10n('ACQUIRING_NEW_REVIEW_BUSINESS_FORMAT_TITLE')}</h3>
                <ul className="business-format__body">
                  {businessFormatReviewItemsData.map((item, index) => (
                    <li key={index} className="business-format__item item-business-format">
                      <h4 className="item-business-format__title">{this.l10n(item.title)}</h4>
                      <p className="item-business-format__text">{this.l10n(item.text)}</p>
                      <ButtonStorybook
                        type="button"
                        className="item-business-format__btn"
                        label={this.l10n('ACQUIRING_NEW_REVIEW_BUSINESS_FORMAT_ITEM_BTN')}
                        aria-label={`${this.l10n('ACQUIRING_NEW_REVIEW_BUSINESS_FORMAT_ITEM_BTN')}: ${this.l10n(item.title)}`}
                        {...getSafeLinkProps(item.href, { navigate: this.navigateAndScrollToContent })}
                        size={"medium"}
                      />
                    </li>
                  ))}
                </ul>
              </div>
            </section>
            <HowToBlockNew
              title={'ACQUIRING_NEW_HOW_TO_BLOCK_TITLE'}
              items={howToBlockItems}
              titleTag={"h3"}
            />
            <section className="advantages-items" aria-labelledby="acquiring-advantages-items-title">
              <div className="container">
                <h3 id="acquiring-advantages-items-title" className="advantages-items__title">{this.l10n('ACQUIRING_NEW_REVIEW_ADVANTAGES_ITEMS_TITLE')}</h3>
                <ul className="advantages-items__body">
                  {advantagesReviewItems.map((item, index) => (
                    <li key={index} className="advantages-items__item item-advantages-items">
                      <h4 className="item-advantages-items__title">{this.l10n(item.title)}</h4>
                      <p className="item-advantages-items__text">{this.l10n(item.text)}</p>
                    </li>
                  ))}
                </ul>
              </div>
            </section>
            <QuestionsAdminNew
              widget={questionsWidgets.review}
              toggleFaqTab={this.toggleFaqTab}
              title={'ACQUIRING_NEW_QUESTIONS_BLOCK_TITLE'}
              loader={this.state.loader}
              titleTag={"h3"}
              questionTag={"h4"}
            />
          </>
          <div className="section-group-spaced">
            {renderTopBlock(topBlockPos)}
            <HowToBlockNew
              title={'ACQUIRING_NEW_HOW_TO_BLOCK_TITLE'}
              items={howToBlockItems}
              titleTag={"h3"}
            />
            {renderFiscalization({
              id: 'pos',
              title: 'ACQUIRING_NEW_POS_FISCALIZATION_TITLE',
              items: fiscalizationPosItems
            })}
            <QuestionsAdminNew
              widget={questionsWidgets.pos}
              toggleFaqTab={this.toggleFaqTab}
              title={'ACQUIRING_NEW_QUESTIONS_BLOCK_TITLE'}
              loader={this.state.widgets_pos_loading}
              titleTag={"h3"}
              questionTag={"h4"}
            />
          </div>
          <div className="section-group-spaced">
            {renderTopBlock(topBlockTaptophone)}
            <HowToBlockNew
              title={'ACQUIRING_NEW_HOW_TO_BLOCK_TITLE'}
              items={howToBlockItems}
              titleTag={"h3"}
            />
            {renderFiscalization({
              id: 'taptophone',
              title: 'ACQUIRING_NEW_TAPTOPHONE_FISCALIZATION_TITLE',
              items: fiscalizationTaptophoneItems
            })}
            <QuestionsAdminNew
              widget={questionsWidgets.taptophone}
              toggleFaqTab={this.toggleFaqTab}
              title={'ACQUIRING_NEW_QUESTIONS_BLOCK_TITLE'}
              loader={this.state.widgets_taptophone_loading}
              titleTag={"h3"}
              questionTag={"h4"}
            />
          </div>
          <div className="section-group-spaced">
            {renderTopBlock(topBlockQr)}
            <HowToBlockNew
              title={'ACQUIRING_NEW_HOW_TO_BLOCK_TITLE'}
              items={howToBlockItems}
              titleTag={"h3"}
            />
            <QuestionsAdminNew
              widget={questionsWidgets.qr}
              toggleFaqTab={this.toggleFaqTab}
              title={'ACQUIRING_NEW_QUESTIONS_BLOCK_TITLE'}
              loader={this.state.widgets_qr_loading}
              titleTag={"h3"}
              questionTag={"h4"}
            />
          </div>
          <div className="section-group-spaced">
            {renderTopBlock(topBlockInternet)}
            <HowToBlockNew
              title={'ACQUIRING_NEW_HOW_TO_BLOCK_TITLE'}
              items={howToBlockItems}
              titleTag={"h3"}
            />
            <Tabs tabs={tabsInternetIntegration} toggle={this.toggleInternetIntegrationTab} tab={this.state.internetIntegrationTab} title={'ACQUIRING_NEW_INTERNET_INTEGRATION_TABS_TITLE'} subtitle={'ACQUIRING_NEW_INTERNET_INTEGRATION_TABS_SUBTITLE'}>
              <>
                {renderFiscalization({
                  id: 'internet-fiscalization',
                  items: fiscalizationInternetFiscalizationItems
                })}
              </>
              <>
                {renderFiscalization({
                  id: 'internet-integrations',
                  items: fiscalizationInternetIntegrationsItems
                })}
              </>
              <>
                {renderFiscalization({
                  id: 'internet-cms',
                  items: fiscalizationInternetCmsItems
                })}
              </>
              <>
                {renderFiscalization({
                  id: 'internet-crm',
                  items: fiscalizationInternetCrmItems
                })}
              </>
              <>
                {renderFiscalization({
                  id: 'internet-api',
                  items: fiscalizationInternetApiItems
                })}
              </>
            </Tabs>
            <QuestionsAdminNew
              widget={questionsWidgets.internet}
              toggleFaqTab={this.toggleFaqTab}
              title={'ACQUIRING_NEW_QUESTIONS_BLOCK_TITLE'}
              loader={this.state.widgets_internet_loading}
              titleTag={"h3"}
              questionTag={"h4"}
            />
          </div>
          <div className="section-group-spaced">
            {renderTopBlock(topBlockVending)}
            <HowToBlockNew
              title={'ACQUIRING_NEW_HOW_TO_BLOCK_TITLE'}
              items={howToBlockItems}
              titleTag={"h3"}
            />
            {renderFiscalization({
              id: 'vending',
              title: 'ACQUIRING_NEW_VENDING_FISCALIZATION_TITLE',
              items: fiscalizationVendingItems
            })}
            <QuestionsAdminNew
              widget={questionsWidgets.vending}
              toggleFaqTab={this.toggleFaqTab}
              title={'ACQUIRING_NEW_QUESTIONS_BLOCK_TITLE'}
              loader={this.state.widgets_vending_loading}
              titleTag={"h3"}
              questionTag={"h4"}
            />
          </div>
        </Tabs>
      </div>
      <div className={`content${!this.state.faqTab ? ' hidden' : ''}`}>
        {Object.keys(questionsWidgets).map(tab => (
          <div key={tab} className={this.state.tab !== tab ? 'faq-tab-hidden' : ''}>
            <FAQStorybook
              widget={questionsWidgets[tab]}
              title={this.l10n('ACQUIRING_NEW_FAQ_STORYBOOK_TITLE')}
              btnText={this.l10n('ACQUIRING_NEW_FAQ_STORYBOOK_BTN_TEXT')}
              onBtnClick={this.toggleFaqTab}
              filterByEnvironment={filterByEnvironment}
            />
          </div>
        ))}
      </div>
      {this.state.showModal && <BusinessOrder attribute="internet" closeModal={this.toggleModal} />}
    </div>
  )
}
